export default "/assets/images/mila-feed-08.cd3817d39d1c7156.mp4";